import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from './auth/components/error/error.component';
import { LogOutComponent } from './auth/components/log-out/log-out.component';
import { SsoComponent } from './auth/components/sso/sso.component';
import { WealthboxAuthCompleteComponent } from './externals/wealthbox-auth-complete/wealthbox-auth-complete.component';
import { WealthboxAuthRedirectComponent } from './externals/wealthbox-auth-redirect/wealthbox-auth-redirect.component';
import { WealthboxAuthErrorComponent } from './externals/wealthbox-auth-error/wealthbox-auth-error.component';
import { SalesforceAuthCompleteComponent } from './externals/salesforce-auth/salesforce-auth-complete/salesforce-auth-complete.component';
import { SalesforceAuthRedirectComponent } from './externals/salesforce-auth/salesforce-auth-redirect/salesforce-auth-redirect.component';
import { SalesforceAuthErrorComponent } from './externals/salesforce-auth/salesforce-auth-error/salesforce-auth-error.component';
import { CoreCommissionsSsoErrorComponent } from './externals/core-commissions/core-commissions-sso-error/core-commissions-sso-error.component';
import { LeadConnectorAuthCompleteComponent } from './externals/leadconnector-auth/leadconnector-auth-complete/leadconnector-auth-complete.component';
import { LeadConnectorAuthRedirectComponent } from './externals/leadconnector-auth/leadconnector-auth-redirect/leadconnector-auth-redirect.component';
import { LeadConnectorAuthErrorComponent } from './externals/leadconnector-auth/leadconnector-auth-error/leadconnector-auth-error.component';

export const AppRoutes: Routes = [
  {
    path: 'Onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule),
    data: {
      title: 'Onboarding',
      state: 'Onboarding'
    }
  },
  {
    path: 'Snapshot',
    loadChildren: () => import('./snapshot/snapshot.module').then(m => m.SnapshotModule),
    data: {
      title: 'Snapshot',
      state: 'Snapshot'
    }
  },
  { path: 'Sso', component: SsoComponent },
  { path: 'NewPortal/Sso', redirectTo: 'Sso' },
  {
    path: 'Logout', component: LogOutComponent, data: {
      title: 'Log Out'
    }
  },
  { path: 'Error', component: ErrorComponent },
  {
    path: 'Externals/WealthboxAuth',
    children: [
      { path: 'Complete', component: WealthboxAuthCompleteComponent },
      { path: 'Redirect', component: WealthboxAuthRedirectComponent },
      { path: 'Error', component: WealthboxAuthErrorComponent },
    ]
  },
  {
    path: 'Externals/SalesforceAuth',
    children: [
      { path: 'Complete', component: SalesforceAuthCompleteComponent },
      { path: 'Redirect', component: SalesforceAuthRedirectComponent },
      { path: 'Error', component: SalesforceAuthErrorComponent },
    ]
  },
  {
    path: 'Externals/LeadConnectorAuth',
    children: [
      { path: 'Complete', component: LeadConnectorAuthCompleteComponent },
      { path: 'Redirect', component: LeadConnectorAuthRedirectComponent },
      { path: 'Error', component: LeadConnectorAuthErrorComponent },
    ]
  },
  {
    path: 'Externals/CoreCommissions',
    children: [
      { path: 'Error', component: CoreCommissionsSsoErrorComponent },
    ]
  },
  {
    path: '',
    redirectTo: 'Portal',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'Portal',
    pathMatch: 'full',
  },
  { path: 'NewPortal/Portal', redirectTo: 'Portal', pathMatch: 'prefix' },
];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes, { paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
